import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeadCell,
    TableRow,
    TextInput,
    Button,
    Spinner
  } from "flowbite-react";
  import {ArrowRight,ArrowLeft,DatabaseZap,Plus} from "lucide-react"
  import axios from "axios";
  import { useEffect, useState } from "react";
  import { useNavigate } from "react-router-dom";
  import moment from 'moment';
  import 'moment/locale/fr';
  import SyncPDVdbModal from "./SyncPDVdbModal";
  const UsersPage = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalUsers, setTotalUsers] = useState(0);
    const [limit] = useState(10);
    const navigate = useNavigate();
    const [openModal,setOpenModal] = useState(false);
  
    const fetchUsers = async (page = 1, search = "") => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}getAllUsers/?page=${page}&limit=${limit}&search=${search}`,
          { withCredentials: true }
        );
        setUsers(response.data.data);
        setTotalPages(response.data.totalPages);
        setCurrentPage(response.data.currentPage);
        setTotalUsers(response.data.total);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };
  
    const handleSearch = (e) => {
      setSearchTerm(e.target.value);
      setCurrentPage(1);
    };
  
    const formatDate = (date) => {
      if (!date) return "N/A";
      return moment(date).format('DD/MM/YYYY HH:mm');
    };

    
  
    useEffect(() => {
      const delayDebounceFn = setTimeout(() => {
        fetchUsers(currentPage, searchTerm);
      }, 500);
  
      return () => clearTimeout(delayDebounceFn);
    }, [searchTerm, currentPage]);
    console.log(users)
    return (
      <section className="dark:bg-gray-900 w-full flex flex-col gap-3 mt-4">
        <div className="grid w-full grid-cols-1">
          <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800 mb-2">
            <div className="w-full sm:w-1/2 p-2">
              <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                Utilisateurs
              </span>
            </div>
            <div className="w-full sm:w-1/2 p-2">
              <TextInput
                type="text"
                placeholder="Rechercher..."
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>
          </div>
      <SyncPDVdbModal openModal={openModal} setOpenModal={setOpenModal}/>
        </div>
        <div className="overflow-x-auto rounded-md ">
          <div className="w-full flex flex-row space-x-4 p-4">
        <Button size={"xs"} color={"dark"} className="  flex " onClick={()=>setOpenModal(true)} ><DatabaseZap size={14} className="mr-2"/> <span>Sync DB</span></Button>
        <Button size={"xs"} color={"dark"} className="   flex " onClick={()=>navigate("/createUser")} ><Plus size={14} className="mr-2"/> <span>Ajouter un utilisateur</span></Button>
        </div>
          <Table striped>
            <TableHead className="bg-gray-50 dark:bg-gray-700 dark:text-white text-gray-900">
              <TableHeadCell ></TableHeadCell>  
              <TableHeadCell ></TableHeadCell>
              <TableHeadCell></TableHeadCell>
              <TableHeadCell ></TableHeadCell>
             
              </TableHead>
            <TableHead>
              <TableHeadCell>Nom d'utilisateur</TableHeadCell>
              <TableHeadCell>Rôle</TableHeadCell>
              <TableHeadCell>Rôle ID</TableHeadCell>
              <TableHeadCell>POS ID Attachée</TableHeadCell>
              <TableHeadCell>Stock Total</TableHeadCell>
            </TableHead>
            <TableBody className="divide-y">
              {users?.length ? users?.map((user, index) => (
                <TableRow 
                  key={index} 
                  className="bg-white dark:border-gray-700 dark:bg-gray-800 cursor-pointer hover:bg-slate-300"
                >
                  <TableCell className="font-bold" onClick={()=>navigate("/settings",{state:{userId : user._id}})}>
                    <span>{user?.username}</span>
                    {user?.details?.pos_franchise_id?.name && (
                      <span className="text-gray-900 dark:text-gray-400"> ({user?.details?.pos_franchise_id?.name})</span>
                    )}
                  </TableCell>
                  <TableCell>{user?.role}</TableCell>
                  <TableCell>{user?.details?._id}</TableCell>
                  <TableCell>{user?.details?.pos_franchise_id?._id || user?.details?.pos_agent_id || 'N/A'}</TableCell>
                  <TableCell>{user?.details?.StockTotal === undefined ? user?.details?.stockTotal : user?.details?.StockTotal }</TableCell>
                </TableRow>
              )) : (
                <TableRow className="bg-white dark:border-gray-700 dark:bg-gray-800">
                  <TableCell colSpan={7} className="text-center">
                    {loading ? <Spinner/> : "Aucun utilisateur trouvé."}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <section className="md:px-4 bg-white dark:bg-gray-800 text-gray-900 dark:text-white rounded-md w-full p-2 flex flex-row justify-between">
          <div className="flex justify-center items-center gap-2">
            <Button
              disabled={currentPage === 1 || totalPages === 0}
              onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
              color="dark"
              size="xs"
            >
              <ArrowLeft size={16} />
            </Button>
            <span className="self-center">
              Page {currentPage} / {totalPages}
            </span>
            <Button
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
              color="dark"
              size="xs"
            >
              <ArrowRight size={16} />
            </Button>
          </div>
          <div>
            <span>Total : {totalUsers}</span>
          </div>
        </section>
      </section>
    );
  };
  
  export default UsersPage;